import { render, staticRenderFns } from "./msgpie.vue?vue&type=template&id=29ab84fa&"
import script from "./msgpie.vue?vue&type=script&lang=js&"
export * from "./msgpie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports